function slideNav($container) {
	if ($container.length) {
		let $linkActive = $container.find('ul > .active').first(),
			$slider = $container.find('.slider');

		if ($linkActive.length) {
			let width = $linkActive.width(),
				left = $linkActive.position().left || 0;

			$linkActive.addClass('hover');

			$slider.css('width', width);
			$slider.css('left', left);
		}

		$container.find('ul > li > a').on('mouseover', function () {
			let $self = $(this),
				$linkActive = $self.closest('li');

			if ($linkActive) {
				let width = $linkActive.width(),
					left = $linkActive.position().left || 0;

				$container.find('.hover').removeClass('hover');
				$linkActive.addClass('hover');

				$slider.css('width', width);
				$slider.css('left', left);
			}

			return false;
		});

		$container.find('ul > li > a').on('mouseout', function () {
			let $linkActive = $container.find('ul > .active').length ? $container.find('ul > .active') : $container.find('ul > li').first() || null;

			if ($linkActive) {
				let width = $linkActive.width(),
					left = $linkActive.position().left;

				$container.find('.hover').removeClass('hover');
				$linkActive.addClass('hover');

				$slider.css('width', width);
				$slider.css('left', left);
			}

			return false;
		});
	}
}

export default slideNav;